import { createSlice } from "@reduxjs/toolkit";

const userInfoSlice = createSlice({
  name: "userInfo",
  initialState: {},
  reducers: {
    setUser: (state, action) => {
      state.userInfo = action.payload;
    },
    logoutUser: (state) => {
      state.userInfo = {};
    },
  },
});

export const { setUser, logoutUser } = userInfoSlice.actions;
export default userInfoSlice.reducer;
